import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RawInput } from '@components/shared/forms';
import { useTranslation } from 'react-i18next';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import { ListingSearchFilterTypes } from '@root/types';
import actions from '@store/actions/listingSearchPage';
import useDebounce from '@shared/useDebounce';

type Props = {
  criteria: ListingSearchCriteria;
  onChange: (criteria: () => ListingSearchCriteria) => void;
  type: ListingSearchFilterTypes;
};

const debounceLength = 1000;

const KeywordsFilter = ({ criteria, onChange, type }: Props) => {
  const { t } = useTranslation('filters');
  const dispatch = useDispatch();
  const [keywords, setKeywords] = useState(criteria.keywords());

  const debouncedCriteria = useDebounce(criteria, debounceLength);

  useEffect(() => {
    // the only time we want to react to this is when clearing
    if (criteria.keywords() === '') {
      setKeywords(criteria.keywords());
    }
  }, [debouncedCriteria]);

  return (
    <>
      <RawInput
        type="text"
        name={`keywords-${type}`}
        placeholder={t('keywords.keywordsPlaceholder')}
        onChange={e => {
          const searchInput = e.currentTarget.value;
          setKeywords(searchInput);
          criteria.changeKeywords(searchInput);
          onChange(() => {
            dispatch(actions.keywordsFilterChanged(searchInput));
            return criteria;
          });
        }}
        value={keywords}
      />
    </>
  );
};
export default KeywordsFilter;
